/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  CompleteSessionResponse,
  CreateSessionResponse,
  CreateTaskRequest,
  CreateTaskResponse,
  FavoriteUrlRequest,
  GetSessionResponse,
  HaltSessionResponse,
  MapString,
  PaginatedResultSessionPublic,
  PaginatedResultTaskPublic,
  Start,
  TaskConfig,
  TaskPublic,
  UpdateTaskRequest,
} from "./data-contracts";
import { ContentType, FullRequestParams, HttpClient, QueryParamsType, RequestParams } from "../http-client";

export class V1<SecurityDataType = unknown> {
  // See templates/api.ejs we need this in order to send as parameter to request call
  serviceName = "kosmotime";
  /**
   * @deprecated Internal use only.
   */
  httpClient: HttpClient<SecurityDataType>;

  constructor(config?: ConstructorParameters<typeof HttpClient<SecurityDataType>>[0]) {
    this.httpClient = new HttpClient(config);
  }

  /**
   * @deprecated Internal use only.
   * See src/http-client we need this so we can send service name to http-client so it knows
   * which service is calling it
   */
  request = <T = any, E = any>(params: FullRequestParams): Promise<T> => {
    return this.httpClient.clientRequest<T, E>({ ...params, serviceName: this.serviceName });
  };

  /**
   * @deprecated Internal use only.
   * See src/http-client we need this so we can send service name to http-client so it knows
   * which service is calling it
   */
  getServicePath = <Q extends QueryParamsType>(path: string, query?: Q): string => {
    const servicePath = this.httpClient.clientGetPath({ path, serviceName: this.serviceName });

    if (!query) return servicePath;

    const queryParams = this.httpClient.encodeQueryParams(query);
    return `${servicePath}?${queryParams}`;
  };

  /**
   * @description Get current config or default to one if it doesn't exist
   *
   * @tags task-config
   * @name GetDefaultConfig
   * @request GET:/v1/tenant/{tenantId}/task-config
   * @secure
   */
  getDefaultConfig = (tenantId: string, params: RequestParams = {}) =>
    this.request<
      TaskConfig,
      | string
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/task-config`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for getDefaultConfig */
  getDefaultConfigPathGetter = (tenantId: string) => this.getServicePath(`/v1/tenant/${tenantId}/task-config`);

  /**
   * @description Setups a task config. Overrides if one exists
   *
   * @tags task-config
   * @name SetupDefaultTaskConfig
   * @request PUT:/v1/tenant/{tenantId}/task-config
   * @secure
   */
  setupDefaultTaskConfig = (tenantId: string, data: TaskConfig, params: RequestParams = {}) =>
    this.request<
      void,
      | string
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/task-config`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });

  /**
   * @description Returns string containing request path for setupDefaultTaskConfig */
  setupDefaultTaskConfigPathGetter = (tenantId: string) => this.getServicePath(`/v1/tenant/${tenantId}/task-config`);

  /**
   * @description List tasks
   *
   * @tags task
   * @name ListTasks
   * @request GET:/v1/tenant/{tenantId}/task
   * @secure
   */
  listTasks = (
    tenantId: string,
    query?: {
      /** @format date-time */
      startDatetime?: string;
      /** @format date-time */
      endDatetime?: string;
      /**
       * Filter tasks for ones containing the link
       * @minLength 1
       */
      containsLink?: string;
      /**
       * @format int64
       * @min 0
       */
      page?: number;
      /**
       * @format int64
       * @exclusiveMin 0
       */
      pageSize?: number;
    },
    params: RequestParams = {},
  ) =>
    this.request<
      PaginatedResultTaskPublic,
      | string
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/task`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for listTasks */
  listTasksPathGetter = (
    tenantId: string,
    query?: {
      /** @format date-time */
      startDatetime?: string;
      /** @format date-time */
      endDatetime?: string;
      /**
       * Filter tasks for ones containing the link
       * @minLength 1
       */
      containsLink?: string;
      /**
       * @format int64
       * @min 0
       */
      page?: number;
      /**
       * @format int64
       * @exclusiveMin 0
       */
      pageSize?: number;
    },
  ) => this.getServicePath(`/v1/tenant/${tenantId}/task`, query);

  /**
   * @description Create a new task
   *
   * @tags task
   * @name CreateTask
   * @request POST:/v1/tenant/{tenantId}/task
   * @secure
   */
  createTask = (tenantId: string, data: CreateTaskRequest, params: RequestParams = {}) =>
    this.request<
      CreateTaskResponse,
      | string
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/task`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for createTask */
  createTaskPathGetter = (tenantId: string) => this.getServicePath(`/v1/tenant/${tenantId}/task`);

  /**
   * @description Get task by id
   *
   * @tags task
   * @name GetTaskById
   * @request GET:/v1/tenant/{tenantId}/task/{taskId}
   * @secure
   */
  getTaskById = (tenantId: string, taskId: string, params: RequestParams = {}) =>
    this.request<
      TaskPublic,
      | string
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/task/${taskId}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for getTaskById */
  getTaskByIdPathGetter = (tenantId: string, taskId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/task/${taskId}`);

  /**
   * @description Update a task
   *
   * @tags task
   * @name UpdateTask
   * @request POST:/v1/tenant/{tenantId}/task/{taskId}
   * @secure
   */
  updateTask = (tenantId: string, taskId: string, data: UpdateTaskRequest, params: RequestParams = {}) =>
    this.request<
      void,
      | string
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/task/${taskId}`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });

  /**
   * @description Returns string containing request path for updateTask */
  updateTaskPathGetter = (tenantId: string, taskId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/task/${taskId}`);

  /**
   * @description Delete a task
   *
   * @tags task
   * @name DeleteTask
   * @request DELETE:/v1/tenant/{tenantId}/task/{taskId}
   * @secure
   */
  deleteTask = (tenantId: string, taskId: string, params: RequestParams = {}) =>
    this.request<
      void,
      | string
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/task/${taskId}`,
      method: "DELETE",
      secure: true,
      ...params,
    });

  /**
   * @description Returns string containing request path for deleteTask */
  deleteTaskPathGetter = (tenantId: string, taskId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/task/${taskId}`);

  /**
   * @description Gets current session
   *
   * @tags session
   * @name GetCurrentSession
   * @request GET:/v1/tenant/{tenantId}/session
   * @secure
   */
  getCurrentSession = (tenantId: string, params: RequestParams = {}) =>
    this.request<
      GetSessionResponse,
      | string
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/session`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for getCurrentSession */
  getCurrentSessionPathGetter = (tenantId: string) => this.getServicePath(`/v1/tenant/${tenantId}/session`);

  /**
   * @description Deletes session
   *
   * @tags session
   * @name DeleteSession
   * @request DELETE:/v1/tenant/{tenantId}/sessions/{sessionId}
   * @secure
   */
  deleteSession = (tenantId: string, sessionId: string, params: RequestParams = {}) =>
    this.request<
      void,
      | string
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/sessions/${sessionId}`,
      method: "DELETE",
      secure: true,
      ...params,
    });

  /**
   * @description Returns string containing request path for deleteSession */
  deleteSessionPathGetter = (tenantId: string, sessionId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/sessions/${sessionId}`);

  /**
   * @description Create a new session. Works only if there is no running session.
   *
   * @tags session
   * @name CreateNewSession
   * @request POST:/v1/tenant/{tenantId}/session/create
   * @secure
   */
  createNewSession = (tenantId: string, data: Start, params: RequestParams = {}) =>
    this.request<
      CreateSessionResponse,
      | string
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/session/create`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for createNewSession */
  createNewSessionPathGetter = (tenantId: string) => this.getServicePath(`/v1/tenant/${tenantId}/session/create`);

  /**
   * @description Halts a current session. Works only if there is running session.
   *
   * @tags session
   * @name HaltSession
   * @request POST:/v1/tenant/{tenantId}/session/halt
   * @secure
   */
  haltSession = (tenantId: string, params: RequestParams = {}) =>
    this.request<
      HaltSessionResponse,
      | string
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/session/halt`,
      method: "POST",
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for haltSession */
  haltSessionPathGetter = (tenantId: string) => this.getServicePath(`/v1/tenant/${tenantId}/session/halt`);

  /**
   * @description Completes current session. Works only if there is running session.
   *
   * @tags session
   * @name CompleteSession
   * @request POST:/v1/tenant/{tenantId}/session/complete
   * @secure
   */
  completeSession = (tenantId: string, params: RequestParams = {}) =>
    this.request<
      CompleteSessionResponse,
      | string
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/session/complete`,
      method: "POST",
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for completeSession */
  completeSessionPathGetter = (tenantId: string) => this.getServicePath(`/v1/tenant/${tenantId}/session/complete`);

  /**
   * @description List all sessions
   *
   * @tags session
   * @name ListSession
   * @request GET:/v1/tenant/{tenantId}/sessions
   * @secure
   */
  listSession = (
    tenantId: string,
    query?: {
      /** @format date-time */
      startDatetime?: string;
      /** @format date-time */
      endDatetime?: string;
      /**
       * Filter by task id
       * @minLength 1
       */
      taskId?: string;
      /**
       * @format int64
       * @min 0
       */
      page?: number;
      /**
       * @format int64
       * @exclusiveMin 0
       */
      pageSize?: number;
    },
    params: RequestParams = {},
  ) =>
    this.request<
      PaginatedResultSessionPublic,
      | string
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/sessions`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for listSession */
  listSessionPathGetter = (
    tenantId: string,
    query?: {
      /** @format date-time */
      startDatetime?: string;
      /** @format date-time */
      endDatetime?: string;
      /**
       * Filter by task id
       * @minLength 1
       */
      taskId?: string;
      /**
       * @format int64
       * @min 0
       */
      page?: number;
      /**
       * @format int64
       * @exclusiveMin 0
       */
      pageSize?: number;
    },
  ) => this.getServicePath(`/v1/tenant/${tenantId}/sessions`, query);

  /**
   * @description Lists all favorite URLs
   *
   * @tags favorite-urls
   * @name ListFavoriteUrLs
   * @request GET:/v1/tenant/{tenantId}/favorite-urls
   * @secure
   */
  listFavoriteUrLs = (tenantId: string, params: RequestParams = {}) =>
    this.request<
      string[],
      | string
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/favorite-urls`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for listFavoriteUrLs */
  listFavoriteUrLsPathGetter = (tenantId: string) => this.getServicePath(`/v1/tenant/${tenantId}/favorite-urls`);

  /**
   * @description Adds a new favorite URL
   *
   * @tags favorite-urls
   * @name AddFavoriteUrl
   * @request POST:/v1/tenant/{tenantId}/favorite-urls
   * @secure
   */
  addFavoriteUrl = (tenantId: string, data: FavoriteUrlRequest, params: RequestParams = {}) =>
    this.request<
      void,
      | string
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/favorite-urls`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });

  /**
   * @description Returns string containing request path for addFavoriteUrl */
  addFavoriteUrlPathGetter = (tenantId: string) => this.getServicePath(`/v1/tenant/${tenantId}/favorite-urls`);

  /**
   * @description Deletes a favorite URL
   *
   * @tags favorite-urls
   * @name DeleteFavoriteUrl
   * @request DELETE:/v1/tenant/{tenantId}/favorite-urls
   * @secure
   */
  deleteFavoriteUrl = (
    tenantId: string,
    query: {
      url: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<
      void,
      | string
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/favorite-urls`,
      method: "DELETE",
      query: query,
      secure: true,
      ...params,
    });

  /**
   * @description Returns string containing request path for deleteFavoriteUrl */
  deleteFavoriteUrlPathGetter = (
    tenantId: string,
    query: {
      url: string;
    },
  ) => this.getServicePath(`/v1/tenant/${tenantId}/favorite-urls`, query);
}
